module.exports = function(s) {
  return ~-encodeURI(s).split(/%..|./).length
}



// WEBPACK FOOTER //
// ./node_modules/utf8-length/index.js